export default __webpack_public_path__ + "d2f02279e3b06e5d9caef25b65054755.png";